import React  from 'react'
import DropDown from '../dropdown';
import { GetCurrency } from '../../../api/services/finance';

const CurrencyDropDown = ({ api = GetCurrency, ...props }) => {
    return <DropDown api={api} search textField="Code" valueField="Id" {...props} />
}

export default CurrencyDropDown
